module.exports = __webpack_public_path__ + "img/xymoxGlas.f93e1072.jpg";